
import { Link } from "react-router-dom";
import { useImperativeHandle, useState } from "react";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/common/components/ui/sidebar";

export function NavMain({ categories, ref }) {
  const [open, setOpen] = useState(true);

  const { pathname: path } = location;
  useImperativeHandle(ref, () => ({
    setOpen,
  }));

  return (
    <>
      {categories.map((category) => {
        const visibleItems = category.items.filter((item) => item.condition);
        if (visibleItems.length === 0) return null;

        return (
          <SidebarGroup key={category.label} className="px-2 py-1">
            <SidebarGroupLabel className="px-3 mb-1 text-[11px] font-semibold tracking-wider text-zinc-400 uppercase">
              {category.label}
            </SidebarGroupLabel>
            <SidebarMenu className="space-y-0.5">
              {visibleItems.map(
                ({ pathMatch, icon: Icon, label, href }, index) => {
                  const isActive = path.startsWith(pathMatch);

                  return (
                    <SidebarMenuItem key={index}>
                      <Link to={href} className="w-full">
                        <SidebarMenuButton
                          isActive={isActive}
                          className={`w-full text-[14px] py-2.5 px-3 rounded-lg transition-all duration-200 flex items-center gap-3 cursor-pointer ${
                            isActive
                              ? "bg-primary text-primary-foreground font-medium shadow-sm hover:bg-primary hover:text-primary-foreground"
                              : "text-zinc-600 font-normal hover:bg-zinc-100 hover:text-zinc-900"
                          }`}
                          tooltip={label}
                        >
                          <Icon
                            className={`w-[18px] h-[18px] flex-shrink-0 ${
                              isActive
                                ? "text-primary-foreground"
                                : "text-zinc-500"
                            }`}
                          />
                          <span className="leading-none">{label}</span>
                        </SidebarMenuButton>
                      </Link>
                    </SidebarMenuItem>
                  );
                }
              )}
            </SidebarMenu>
          </SidebarGroup>
        );
      })}
    </>
  );
}
